import React, { useState,useEffect } from 'react';
import Header from './Header';
import Landing from './landing';
import About from './about';
import Createteam from './CreateTeam';
import FAQ from './FAQ';
import Footer from './Footer';


const Home = ()=>{

    return(
        <div>
            <Header/>
            <Landing/>
            <About/>
            <Createteam/>  
            <FAQ/>
            <Footer/>
        </div>

    );

}

export default Home;